export enum FollowStreamType {
  WORKSPACE_TAG = 'workspace_tag',
  USER_PROFILE = 'user_profile',
}
